import axios from '../axios/AxiosInstance';
import { startOfISOWeek, addWeeks } from 'date-fns';
import { contractDate } from '../utils/planningDates';

let cache;
export function contractsEndingInWeek(contracts, now = new Date()) {
  const start = startOfISOWeek(now);
  const end = addWeeks(start, 1);
  return contracts.filter(contract => {
    const date = contractDate(contract.DateFinMission || contract.DateFin);
    return date && date >= start && date < end;
  });
}
export function loadProlongationContracts() {
  const scope = JSON.stringify([localStorage.getItem('accessToken'), localStorage.getItem('agencyId'), localStorage.getItem('agencyName')]);
  if (cache?.scope === scope && (cache.pending || Date.now() - cache.savedAt < 30000)) return cache.promise;
  const entry = { scope, pending: true };
  cache = entry;
  entry.promise = axios.get('pld-contract/freelance').then(({data}) => {
    if (!Array.isArray(data)) throw new Error('Liste des contrats invalide');
    entry.pending = false; entry.savedAt = Date.now();
    return data;
  }).catch(error => { if (cache === entry) cache = undefined; throw error; });
  return entry.promise;
}
